// Decorative wireframe preview for an overlay section on the console's
// Overlays tab — the design canvas draws each overlay as an abstract
// composition over the dimmed package key art. Purely visual: shapes are
// static hints of the real overlay's layout, not live renders.
//
// Slugs without a shape map render nothing (custom overlays, bracket).

const BAR = (extra) => ({ position: 'absolute', ...extra });

const SHAPES = {
  'starting-soon': [
    BAR({ left: '50%', top: '16%', transform: 'translateX(-50%)', width: '12%', height: 4, background: 'rgba(255,45,120,0.8)', boxShadow: '0 0 8px rgba(255,45,120,0.5)' }),
    BAR({ left: '50%', top: '32%', transform: 'translateX(-50%)', width: '36%', height: 8, background: 'rgba(255,255,255,0.75)' }),
    BAR({ left: '50%', top: '50%', transform: 'translateX(-50%)', width: '20%', height: 4, background: 'rgba(138,143,166,0.55)' }),
    BAR({ left: '50%', top: '62%', transform: 'translateX(-50%)', width: '17%', height: '24%', border: '1px solid rgba(0,212,255,0.8)', boxShadow: '0 0 12px rgba(0,212,255,0.3), inset 0 0 10px rgba(0,212,255,0.12)' }),
  ],
  'be-right-back': [
    BAR({ left: '50%', top: '34%', transform: 'translateX(-50%)', width: '32%', height: 9, background: 'rgba(255,255,255,0.75)' }),
    BAR({ left: '50%', top: '56%', transform: 'translateX(-50%)', width: '14%', height: '18%', border: '1px solid rgba(0,212,255,0.8)', boxShadow: '0 0 12px rgba(0,212,255,0.3)' }),
  ],
  'winner-screen': [
    BAR({ left: '50%', top: '30%', transform: 'translateX(-50%) skewX(-8deg)', width: '42%', height: '17%', background: 'linear-gradient(90deg, rgba(255,45,120,0.75), rgba(0,212,255,0.75))', boxShadow: '0 0 16px rgba(255,45,120,0.35)' }),
    BAR({ left: '50%', top: '58%', transform: 'translateX(-50%)', width: '22%', height: 5, background: 'rgba(255,255,255,0.7)' }),
    BAR({ left: '50%', top: '72%', transform: 'translateX(-50%)', width: '12%', height: 4, background: 'rgba(138,143,166,0.5)' }),
  ],
  'in-match': [
    BAR({ left: '5%', top: '7%', width: '34%', height: '9%', background: 'linear-gradient(90deg, rgba(255,45,120,0.85), rgba(255,45,120,0.3))', clipPath: 'polygon(0 0, 100% 0, calc(100% - 10px) 100%, 0 100%)', boxShadow: '0 0 10px rgba(255,45,120,0.35)' }),
    BAR({ right: '5%', top: '7%', width: '34%', height: '9%', background: 'linear-gradient(270deg, rgba(0,212,255,0.85), rgba(0,212,255,0.3))', clipPath: 'polygon(10px 0, 100% 0, 100% 100%, 0 100%)', boxShadow: '0 0 10px rgba(0,212,255,0.35)' }),
    BAR({ left: '50%', top: '6%', transform: 'translateX(-50%)', width: '9%', height: '11%', background: '#0e1120', border: '1px solid rgba(255,255,255,0.35)' }),
    BAR({ left: '41.5%', top: '8.5%', width: '2.5%', height: '6%', background: 'rgba(255,45,120,0.9)' }),
    BAR({ right: '41.5%', top: '8.5%', width: '2.5%', height: '6%', background: 'rgba(0,212,255,0.9)' }),
    BAR({ left: '5%', bottom: '8%', width: '22%', height: '5%', background: 'rgba(255,255,255,0.18)' }),
    BAR({ right: '5%', bottom: '8%', width: '22%', height: '5%', background: 'rgba(255,255,255,0.18)' }),
  ],
  // Mirrors the real camera_feed.html composition: brand tab top-left,
  // round/live tab top-right, two EQUAL cams (player + gameplay) with the
  // tournament logo at their seam, the rotating sponsor band, and the
  // P1-vs-P2 match banner along the very bottom.
  'camera-feed': [
    BAR({ left: '3%', top: '5%', width: '16%', height: '8%', background: 'rgba(255,255,255,0.10)', borderLeft: '2px solid rgba(255,45,120,0.7)' }),
    BAR({ right: '3%', top: '5%', width: '13%', height: '7%', background: 'rgba(255,255,255,0.08)' }),
    BAR({ left: '9%', top: '17%', width: '39%', height: '37%', border: '1px dashed rgba(255,45,120,0.65)', boxShadow: '0 0 10px rgba(255,45,120,0.2)' }),
    BAR({ right: '9%', top: '17%', width: '39%', height: '37%', border: '1px dashed rgba(255,45,120,0.65)', boxShadow: '0 0 10px rgba(255,45,120,0.2)' }),
    BAR({ left: '50%', top: '44%', transform: 'translateX(-50%)', width: '9%', height: '12%', border: '1px solid rgba(0,212,255,0.75)', boxShadow: '0 0 10px rgba(0,212,255,0.3)' }),
    BAR({ left: '6%', top: '62%', width: '88%', height: '20%', background: 'rgba(255,255,255,0.10)' }),
    BAR({ left: '3%', bottom: '3%', width: '42%', height: '9%', background: 'linear-gradient(90deg, rgba(255,45,120,0.5), rgba(255,45,120,0.12))', clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 100%, 0 100%)' }),
  ],
  'thank-you': [
    BAR({ left: '50%', top: '30%', transform: 'translateX(-50%)', width: '38%', height: 8, background: 'rgba(255,255,255,0.7)' }),
    BAR({ left: '50%', top: '47%', transform: 'translateX(-50%)', width: '24%', height: 5, background: 'linear-gradient(90deg, rgba(255,45,120,0.8), rgba(0,212,255,0.8))', boxShadow: '0 0 8px rgba(255,45,120,0.3)' }),
    BAR({ left: '50%', top: '60%', transform: 'translateX(-50%)', width: '15%', height: 4, background: 'rgba(138,143,166,0.5)' }),
    BAR({ left: '44%', bottom: '12%', width: 22, height: 7, background: 'rgba(255,255,255,0.2)' }),
    BAR({ left: '48.5%', bottom: '12%', width: 22, height: 7, background: 'rgba(255,255,255,0.2)' }),
    BAR({ left: '53%', bottom: '12%', width: 22, height: 7, background: 'rgba(255,255,255,0.2)' }),
  ],
  'top-8': [
    BAR({ left: '7%', top: '16%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.6)' }),
    BAR({ left: '7%', top: '37%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.35)' }),
    BAR({ left: '7%', top: '58%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.35)' }),
    BAR({ left: '7%', top: '79%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.2)' }),
    BAR({ right: '7%', top: '16%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.6)' }),
    BAR({ right: '7%', top: '37%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.35)' }),
    BAR({ right: '7%', top: '58%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.35)' }),
    BAR({ right: '7%', top: '79%', width: '22%', height: '9%', background: 'rgba(255,255,255,0.2)' }),
    BAR({ left: '36%', top: '30%', width: '11%', height: '7%', background: 'rgba(255,45,120,0.65)', boxShadow: '0 0 8px rgba(255,45,120,0.4)' }),
    BAR({ right: '36%', top: '30%', width: '11%', height: '7%', background: 'rgba(0,212,255,0.65)', boxShadow: '0 0 8px rgba(0,212,255,0.4)' }),
    BAR({ left: '50%', top: '52%', transform: 'translateX(-50%)', width: '16%', height: '10%', border: '1px solid rgba(255,171,0,0.8)', boxShadow: '0 0 10px rgba(255,171,0,0.3)' }),
  ],
};

// Field captions over the wireframe — each names the console input (or live
// data source) that renders at that spot on the real overlay.
const LBL = (text, pos) => ({ text, style: { position: 'absolute', transform: 'translateX(-50%)', ...pos } });

// The KEC packages' screens have no hashtag or handle (taken off at the
// club's ask, 2026-10-25; migration 0057), so their wireframes don't name them.
const NO_HASHTAG_PACKAGES = new Set(['valorant', 'marvel-rivals']);
const HASHTAG_CAPTIONS = new Set(['Hashtag', 'Handle']);

const LABELS = {
  'starting-soon': [
    LBL('Hashtag', { left: '50%', top: '20.5%' }),
    LBL('Tournament name', { left: '50%', top: '37%' }),
    LBL('Day', { left: '50%', top: '54%' }),
    LBL('Countdown', { left: '50%', top: '71%' }),
  ],
  'be-right-back': [
    LBL('Tournament name', { left: '50%', top: '41%' }),
    LBL('Countdown', { left: '50%', top: '62%' }),
  ],
  'winner-screen': [
    LBL('Prefix + name', { left: '50%', top: '35%' }),
    LBL('Character', { left: '50%', top: '63%' }),
  ],
  'in-match': [
    LBL('Player 1 · live', { left: '22%', top: '19%' }),
    LBL('Round', { left: '50%', top: '20%' }),
    LBL('Player 2 · live', { left: '78%', top: '19%' }),
  ],
  'camera-feed': [
    LBL('Round · live', { left: '90.5%', top: '6.8%' }),
    LBL('Player cam', { left: '28.5%', top: '33%' }),
    LBL('Gameplay feed', { left: '71.5%', top: '33%' }),
    LBL('Tournament logo', { left: '50%', top: '57.5%' }),
    LBL('Sponsors · rotating tiers', { left: '50%', top: '70%' }),
    LBL('P1 vs P2 · live', { left: '24%', top: '90.3%' }),
  ],
  'thank-you': [
    LBL('Tournament name', { left: '50%', top: '36.5%' }),
    LBL('Hashtag', { left: '50%', top: '52.5%' }),
    LBL('Handle', { left: '50%', top: '65.5%' }),
    LBL('Sponsors', { left: '50%', bottom: '3.5%' }),
  ],
  'top-8': [
    LBL('Standings', { left: '18%', top: '6.5%' }),
    LBL('Finalists', { left: '50%', top: '21%' }),
    LBL('Champion', { left: '50%', top: '55.5%' }),
  ],
};

export default function OverlayPreview({ slug, packageSlug, tall = false }) {
  const shapes = SHAPES[slug];
  if (!shapes) return null;
  const labels = (LABELS[slug] ?? []).filter(
    (l) => !(NO_HASHTAG_PACKAGES.has(packageSlug) && HASHTAG_CAPTIONS.has(l.text)),
  );
  return (
    <span
      className={`pp-preview${tall ? ' pp-preview--tall' : ''}`}
      aria-hidden="true"
      style={{
        backgroundImage:
          'linear-gradient(rgba(10,11,18,0.88), rgba(12,13,22,0.93)),'
          + ` url(/api/packages/${packageSlug}/art/card)`,
      }}
    >
      {shapes.map((s, i) => <span key={i} style={s} />)}
      {labels.map((l, i) => (
        <span key={`l${i}`} className="pp-preview__lbl" style={l.style}>{l.text}</span>
      ))}
      <span className="pp-preview__tag">PREVIEW · 1920×1080</span>
    </span>
  );
}
